import React, { memo } from "react";
import { useRotationWarningOverlay } from "./index.hooks";
import { Box, Stack, Typography } from "@mui/material";

type RotationWarningOverlayProps = {};

export const RotationWarningOverlay = memo(
  ({}: RotationWarningOverlayProps) => {
    const { isMobileLandscape } = useRotationWarningOverlay();

    return (
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          zIndex: 100,
          backgroundColor: "rgba(0,0,0,0.9)",
          display: isMobileLandscape ? "flex" : "none",
        }}
      >
        <Stack
          spacing={5}
          justifyContent="center"
          sx={{
            height: "100%",
            width: "100%",
            p: 5,
          }}
        >
          <Typography
            variant="h3"
            sx={{
              textAlign: "center",
              textTransform: "none",
              fontFamily: "futura",
            }}
          >
            Ruota il dispositivo
          </Typography>
          <Typography
            variant="h4"
            sx={{
              textAlign: "center",
              textTransform: "none",
              fontFamily: "futura",
            }}
          >
            Mantieni il dispositivo in verticale per continuare a giocare
          </Typography>
        </Stack>
      </Box>
    );
  },
);
